module.exports = __webpack_public_path__ + "static/media/franchise.a53f2777.png";